import {
  COL_FILTER_HEADER_ACCOUNT,
  COL_FILTER_HEADER_ENTITLEMENT,
  COL_FILTER_HEADER_ROLE,
  COL_FILTER_HEADER_USER,
  OBJECTS_TO_BE_INCLUDED_ACCOUNTS,
  OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS,
  OBJECTS_TO_BE_INCLUDED_ROLES,
  OBJECTS_TO_BE_INCLUDED_USERS,
  ORDER_OF_COL_FILTERS,
  PRIORITY_COLUMNS,
} from './constant';

export const getActiveFiltersForCols = (obj) => {
  const checkedOptions = {};

  obj.forEach((filter) => {
    checkedOptions[filter.value] = [];
    filter.options.forEach((option) => {
      if (option.isChecked === true) {
        checkedOptions[filter.value].push(option.value);
      }
    });
  });

  return checkedOptions;
};

const reCreateColOptions = (options, key, orderColumnsPriority) => {
  const tempOptions = [];

  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const optionKey in options) {
    tempOptions.push({
      label: `${options[optionKey]}`,
      value: `${key}-${optionKey}`,
      isChecked: true,
    });
  }

  if (orderColumnsPriority) {
    const reOrderedOption = tempOptions.toSorted(
      (a, b) =>
        PRIORITY_COLUMNS.indexOf(b.value) - PRIORITY_COLUMNS.indexOf(a.value)
    );

    return reOrderedOption;
  }

  return tempOptions;
};

export const sanitizeColFilters = (
  filters,
  orderColumnsPriority,
  allowedFilters = []
) => {
  const tempColFilters = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const key in filters) {
    if (Object.prototype.hasOwnProperty.call(filters, key)) {
      let isDisabled = false;
      const options = reCreateColOptions(
        filters[key],
        key.toUpperCase(),
        orderColumnsPriority
      );

      if (
        key === COL_FILTER_HEADER_USER &&
        !allowedFilters.includes(OBJECTS_TO_BE_INCLUDED_USERS)
      ) {
        isDisabled = true;
      }

      if (
        key === COL_FILTER_HEADER_ROLE &&
        !allowedFilters.includes(OBJECTS_TO_BE_INCLUDED_ROLES)
      ) {
        isDisabled = true;
      }

      if (
        key === COL_FILTER_HEADER_ACCOUNT &&
        !allowedFilters.includes(OBJECTS_TO_BE_INCLUDED_ACCOUNTS)
      ) {
        isDisabled = true;
      }

      if (
        key === COL_FILTER_HEADER_ENTITLEMENT &&
        !allowedFilters.includes(OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS)
      ) {
        isDisabled = true;
      }

      tempColFilters.push({
        label: `${key}`,
        value: `${key.toUpperCase()}`,
        isDisabled,
        options,
      });
    }
  }

  return tempColFilters.sort(
    (a, b) =>
      ORDER_OF_COL_FILTERS.indexOf(a.label) -
      ORDER_OF_COL_FILTERS.indexOf(b.label)
  );
};
